
const initSearch = () => {
  const searchButton = document.getElementsByClassName('hero__nav-section--search')[0];
  const searchModal = document.getElementsByClassName('search-form')[0];

  const handleEscape = event => {
    if(event.key === "Escape"){
      closeModal();
    }
  };

  const handleClickOut = event => {
    const { target } = event;

    if (target.classList.contains('search-form')) {
      closeModal();
    }
  };

  const closeModal = () => {
    document.removeEventListener('keydown', handleEscape, true);
    searchModal.removeEventListener('click', handleClickOut, true);

    searchModal.classList.remove('active');
  };

  const openModal = () => {
    document.addEventListener('keydown', handleEscape, true);
    searchModal.addEventListener('click', handleClickOut, true);

    searchModal.classList.add('active');

    document.getElementsByClassName('search-form__input')[0].focus();
  };

  searchButton.addEventListener('click', () => {
    openModal();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initSearch();
});
